import styled from 'styled-components'

const Heading = styled.h2`
  color: ${({ theme }) => theme.colors.slate};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin: 0;
`

export default Heading
